import { render, staticRenderFns } from "./viewInformation.vue?vue&type=template&id=3698c23a&scoped=true"
import script from "./viewInformation.vue?vue&type=script&lang=js"
export * from "./viewInformation.vue?vue&type=script&lang=js"
import style0 from "./viewInformation.vue?vue&type=style&index=0&id=3698c23a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698c23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3698c23a')) {
      api.createRecord('3698c23a', component.options)
    } else {
      api.reload('3698c23a', component.options)
    }
    module.hot.accept("./viewInformation.vue?vue&type=template&id=3698c23a&scoped=true", function () {
      api.rerender('3698c23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/extractConfigurationItem/components/viewInformation.vue"
export default component.exports